export const getDictionaryEntriesList = ({ dictionaryEntries }) =>
  dictionaryEntries.list.data.items;

export const getSelectedEntries = ({ dictionaryEntries }) =>
  dictionaryEntries.list.data.selected;

export const getDictionaryEntriesListCount = ({ dictionaryEntries }) =>
  dictionaryEntries.list.data.count;

export const getIsLoadingList = ({ dictionaryEntries }) =>
  dictionaryEntries.list.isLoading;

export const getPaginationOptions = ({ dictionaryEntries }) =>
  dictionaryEntries.list.paginationOptions;

export const getIsAdding = ({ dictionaryEntries }) =>
  dictionaryEntries.add.isLoading;

export const getIsUpdating = ({ dictionaryEntries }) =>
  dictionaryEntries.update.isLoading;

export const getIsDeleting = ({ dictionaryEntries }) =>
  dictionaryEntries.delete.isLoading;
